<template>
  <v-dialog
    v-model="showDialog"
    max-width="500px"
    v-if="[TypeRole.ADMINISTRADOR, TypeRole.OPERADOR].includes(role) || auth || request_change_confirme"
  >
    <v-form
      ref="form"
      v-model="valid"
      @keyup.native.enter.prevent="valid && save()"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Cambiar Contraseña</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="entry.clave"
                  maxlength="20"
                  counter
                  :label="'Nueva ' + $t('auth.password').toLocaleLowerCase()"
                  id="i_reset_password_dialog_clave"
                  :rules="passwordRules"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  autocomplete="off"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="entry.clave_2"
                  maxlength="20"
                  counter
                  :label="$t('auth.password_confirmation')"
                  :rules="passwordConfirmationmRules"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  autocomplete="off"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <div v-if="!request_change_confirme">
            <v-btn color="error" class="mr-2" dark @click="close" :disabled="loading">
              <v-icon small>mdi-cancel</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ $t("common.close") }}
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" class="mr-2" dark @click="close" :disabled="loading" to="/login">
              <v-icon small>mdi-cancel</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ $t("common.close") }}
            </v-btn>
          </div>
          <v-btn
            type="submit"
            form="form"
            color="blue darken-1 white--text"
            :disabled="!valid || loading || !entry.clave"
            :loading="loading"
            @click="save()"
          >
            <v-icon small>mdi-content-save</v-icon>
            <v-divider class="mx-4" inset vertical></v-divider>
            {{ $t("common.update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import messageMixin from "@/mixins/common"

export default {
  name: "reset-password-dialog",
  mixins: [messageMixin],
  props: {
    user_id: {
      type: Number,
      default: null
    },
    auth: { // True cuando se intenta actualizar la contraseña del usuario actualmente autenticado
      type: Boolean,
      default: false
    },
    request_change_confirme: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      entry: {
        clave: "",
        clave_2: "",
      },
      passwordRules: [
        v => !!v || this.$t("validations.required", { field: "La contraseña" }),
        v =>
          (v && v.length >= 6) ||
          this.$t("validations.minLength", {
            field: "La contraseña",
            length: 6,
          }),
      ],
      passwordConfirmationmRules: [
        v => !!v || this.$t("validations.required", { field: "La contraseña" }),
        v =>
          (v && v.length >= 6) ||
          this.$t("validations.minLength", {
            field: "La contraseña",
            length: 6,
          }),
        v =>
          v === this.entry.clave ||
          this.$t("validations.password_confirmation"),
      ],
      showPassword: false,
      showDialog: false,
    }
  },
  computed: {
    ...mapState(["TypeRole"]),
    ...mapState("Auth", ["messageError"]),
    ...mapGetters("Auth", ["role"]),
  },
  methods: {
    ...mapActions("Auth", ["changePassword", "changePasswordPersona"]),
    save() {
      this.loading = true
      const request = this.auth
        ? this.changePassword({ clave: this.entry.clave })
        : this.changePasswordPersona({
            id: this.user_id,
            clave: this.entry.clave,
            link_temporal: this.$route.params.link_temporal || null
          })
      request.then(response => {
        if (response) {
          this.updateMessage(
            "La Contraseña",
            this.callback
          )
          this.close()
          return
        }

        this.errorMessage(this.messageError)
      })
      .finally(() => (this.loading = false))
    },
    close() {
      this.showDialog = false
    },
    resetForm() {
      this.showPassword = false
      setTimeout(() => {
        this.$refs.form.reset()
        document.getElementById("i_reset_password_dialog_clave").focus()
      }, 30)
    },
  },
  mounted() {
    if (this.request_change_confirme)
      this.showDialog = this.request_change_confirme
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.resetForm()
      }
    }
  },
}
</script>
